import {
  GET_SUPERADMINS_SUCCESS,
  GET_SUPERADMINS_FAILURE,
} from '../../../../config/constants/ActionTypes'

export default (state = {}, action) => {
  switch (action.type) {
    case GET_SUPERADMINS_SUCCESS: {
      return {
        ...state,
        superadmins: action.payload.superadmins,
      }
    }

    case GET_SUPERADMINS_FAILURE: {
      return {
        ...state,
        getSuperadminsError: action.payload.error,
      }
    }

    default:
      return state
  }
}
